import { Guid } from 'guid-typescript';

export class GetAudit{
  static readonly type = '[AuditReport] Get  Audit';
}

export class GetAllAuditDetails {
  static readonly type = '[AuditReport] Get All Audit Details';
}

export class GetAuditBasedonId {
  static readonly type = '[AuditReport] Get Audit Based on Id';

  constructor(public auditId: Guid) {}
}

export class SaveAuditDetails {
  static readonly type = '[AuditReport] Save Audit Details';

  constructor(public auditDetails: any) {}
}
export class GetAuditReportDetailsByType {
  static readonly type = '[AuditReport] Get Audit Report Details By Type';

  constructor(public type: any) {}
}
export class SaveAuditReportDetails {
  static readonly type = '[AuditReport] Save Audit Report Details';

  constructor(public reportDetails: any) {}
}
